import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
// @ts-ignore
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { CheckboxFilters } from '~/src/components/CheckboxFilters';
import FilterMenu from '~/src/components/FilterMenu';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';

export const Tariffs = styled.div`
    width: 100%;
    flex-direction: column;
    padding: 30px 0;
    background-color: ${COLORS.GRAY_XS};
    z-index: 1;
`;

export const StyledGridContainer = styled(GridContainer)`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

    @media (max-width: ${breakePoints.desktop}) {
        padding-left: 0;
        padding-right: 0;
    }

    @media (max-width: ${breakePoints.mobile}) {
        padding-left: 16px;
        padding-right: 16px;
    }
`;

export const Title = styled.h2`
    width: 100%;
    margin-bottom: 30px;
    ${FONTS.H2};

    @media (max-width: ${breakePoints.desktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakePoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const Actions = styled.div`
    width: 100%;
    align-items: center;
    justify-content: space-beetwen;
    flex-direction: row;
    margin-bottom: 12px;
`;

export const NewTariffMenu = styled(FilterMenu)`
    margin: 0 !important;
`;

export const SCheckboxFilters = styled(CheckboxFilters)`
    @media (max-width: ${breakePoints.tablet}) {
        div:first-child {
            margin-left: 0;
        }
    }
    @media (max-width: ${breakePoints.mobile}) {
        div {
            margin-left: 0;
            
            &:not(:last-child) {
                margin-bottom: 16px;
            }
        }
    }
`;

export const BtnWrapper = styled.div`
    width: 100%;
    justify-content: center;
`;
